function parseS3Uri(uri: string): { bucket: string; key: string } {
  const match = /^s3:\/\/([^/]+)\/(.+)$/.exec(uri);

  if (!match) {
    throw new Error(`Invalid S3 URI: ${uri}`);
  }

  const [, bucket, key] = match;

  return { bucket, key };
}

export default parseS3Uri;
